export const HHSTitle = "HHS Management Console";
